import clsx from 'clsx';
import type { ButtonHTMLAttributes } from 'react';

/**
 * Botão primário da tela de login. Fundo `auth-marca-forte`, não
 * `auth-marca`: branco sobre `#3B82F6` mede 3.68:1 (reprova AA texto normal,
 * 4.5:1) — ver o comentário de `--color-auth-marca` em `estilos.css`.
 *
 * `type="button"` por padrão, igual `Botao` de `componentes/ui.tsx`: quem
 * usa dentro de um `<form>` (o `LoginForm`) passa `type="submit"` explícito.
 */
interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  carregando?: boolean;
}

export function PrimaryButton({
  carregando = false,
  className,
  children,
  disabled,
  ...resto
}: PrimaryButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled === true || carregando}
      aria-busy={carregando}
      className={clsx(
        'inline-flex h-11 w-full items-center justify-center gap-2 rounded-auth-controle',
        'bg-auth-marca-forte text-auth-marca-contraste text-sm font-medium',
        'hover:bg-auth-marca-forte-hover transition-[transform,opacity,box-shadow] duration-300 ease-out',
        'focus-visible:ring-auth-marca-hover/35 focus-visible:outline-none focus-visible:ring-2',
        'disabled:cursor-not-allowed disabled:opacity-60',
        className,
      )}
      {...resto}
    >
      {carregando && (
        <span
          aria-hidden
          className="size-4 animate-spin rounded-full border-2 border-current border-t-transparent"
        />
      )}
      {children}
    </button>
  );
}
